import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderCancelListContainer from '../../containers/order/OrderCancelListContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderCancelList = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_CANCEL_LIST}>
      <OrderCancelListContainer pageName={ORDER_PAGE_NAME.ORDER_CANCEL_LIST} />
    </PageTemplate>
  );
};

export default OrderCancelList;
